var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title-bar-scroll-page',{ref:"container",attrs:{"show-title-bar":false,"title":"检查数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }